import { useUpdatePurchasesPermissions } from 'src/components/Purchases/BulkActions/useUpdatePurchasesPermissions';
import { Content } from 'src/contexts/ContentContext';
import { PosDropdownItem } from 'src/core/POS/PosDropdown';
import { Stack } from 'src/core/ui';
import { ContentId } from 'src/utils/constants/contentId';

export const LaunchBulkCancelPurchase = ({
  onClick,
  disabled,
}: {
  onClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
  disabled?: boolean;
}) => {
  const { hasUpdatePurchasesPermission } = useUpdatePurchasesPermissions();

  if (!hasUpdatePurchasesPermission) {
    return null;
  }

  return (
    <>
      <PosDropdownItem
        key="bulk-cancel-purchases"
        onClick={onClick}
        disabled={disabled}
      >
        <Stack gap="m" alignItems="center" width="full">
          <Content id={ContentId.CancelPurchasesParenth} />
        </Stack>
      </PosDropdownItem>
    </>
  );
};
